import { sessionStorage, lawyerApi } from "./http";

export async function loginLawyer(payload) {
  const { data } = await lawyerApi.post("/auth/login", payload);
  return data;
}

export async function registerLawyer(payload) {
  const body = {
    full_name: payload?.name || payload?.full_name || "",
    email: payload?.email || "",
    phone_number: payload?.phone || payload?.phone_number || "",
    city: payload?.city || "",
    pincode: payload?.pincode || "",
    role: "lawyer",
  };

  const { data } = await lawyerApi.post("/auth/signup", body);
  return data;
}

export async function googleLawyerAuth(idToken, role = "lawyer") {
  const safeRole = role === "lawyer" ? "lawyer" : "client";
  const { data } = await lawyerApi.post(`/auth/google?role=${encodeURIComponent(safeRole)}`, {
    idToken,
    role: safeRole,
  });
  return data;
}

export async function completeGoogleProfile(payload) {
  const { data } = await lawyerApi.post("/auth/complete-profile", payload);
  return data;
}

export async function sendOtp(phone) {
  const { data } = await lawyerApi.post("/otp/send", { phone });
  return data;
}

export async function verifyOtp(phone, otp) {
  const { data } = await lawyerApi.post("/otp/verify", { phone, otp });
  return data;
}

export async function verifySession() {
  const { data } = await lawyerApi.post("/auth/verify");
  return data;
}

export async function changePassword(payload) {
  const { data } = await lawyerApi.post("/auth/change-password", payload);
  return data;
}

export function persistLawyerSession({ token, user }) {
  if (!token || !user) return;
  localStorage.setItem(sessionStorage.TOKEN_KEY, token);
  localStorage.setItem(sessionStorage.USER_KEY, JSON.stringify(user));
}
